import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { ICandidate, ICandidateRevenue, IJob, getCandidaterevenue, getJobById } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import { AccessControl } from '../../../../../components';
import PotentialRevenue from '../../../../../features/jobs/listing/components/viewJd/potentialRevenue/PotentialRevenue';

interface ICandidateRevenueProps {
  candidateInteractionId?: string;
  isPotentialRevenueTabVisible?: boolean | '';
  jobId: string;
  candidateInteraction?: ICandidate;
}

const CandidateRevenue = ({
  candidateInteractionId,
  isPotentialRevenueTabVisible,
  jobId,
  candidateInteraction,
}: ICandidateRevenueProps) => {
  const [candidateRevenue, setCandidateRevenue] = useState<ICandidateRevenue | undefined>(
    undefined
  );
  const [job, setJob] = useState<IJob | undefined>(undefined);

  useEffect(() => {
    const fetchRevenueData = async () => {
      const revenueData: ICandidateRevenue = (
        await getCandidaterevenue(candidateInteractionId ?? '')
      ).data;
      revenueData && setCandidateRevenue(revenueData);
    };

    candidateInteractionId && fetchRevenueData();
  }, [candidateInteractionId]);

  useEffect(() => {
    const fetchJobData = async () => {
      const jobData: IJob = (await getJobById(jobId)).data;
      jobData && setJob(jobData);
    };

    jobId && fetchJobData();
  }, [jobId]);

  return isPotentialRevenueTabVisible ? (
    <Grid
      container
      xs={12}
      sx={{ background: WsColors.White, paddingLeft: '10%' }}
      p={1}
      display="flex"
      justifyContent="flex-end"
    >
      <PotentialRevenue
        candidateRevenueInfo={candidateRevenue}
        candidateInteractionInfo={candidateInteraction}
        jobInfo={job}
      />
    </Grid>
  ) : (
    <AccessControl />
  );
};

export default CandidateRevenue;
